import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const Widget = (props) => {
  if (!props.loaded) {
    return <div />;
  }

  return (
    <div className="text-center">
      <p>Opportunities Available</p>
      <p className="heading">{props.count}</p>
    </div>
  );
};

Widget.propTypes = {
  loaded: PropTypes.bool,
  count: PropTypes.number,
};

Widget.defaultProps = {
  loaded: false,
  count: 0,
};

const mapStateToProps = state => ({
  count: state.opportunityCount.count,
  loaded: state.opportunityCount.loaded,
});

export default connect(mapStateToProps)(Widget);
